// Designs observed in the reference app (user-supplied screenshots, Oct 2026), snapped to the exact colours published
// on the reference website. Generated from reference/real-app + reference/evidence/site-designs.json.
// [id, paper, pattern, line, ink, accent]
import type { Pattern } from "../storage/schemas";

export type RealDesign = [id: string, paper: string, pattern: Pattern, line: string, ink: string, accent: string];

export const REAL_SECTIONS: { title: string; ids: string[] }[] = [{"title":"Original","ids":["d000","d001"]},{"title":"Clear","ids":["d100","d101","d102","d103"]},{"title":"Colorful","ids":["d002","d003","d004","d005","d006","d007","d008","d009"]},{"title":"Retro","ids":["d010","d011","d012","d013","d014","d015","d016","d017","d018","d019"]},{"title":"Sticky Notes","ids":["d050","d051","d052","d053","d054","d055","d056","d057","d058","d059"]},{"title":"Cute","ids":["d020","d021","d022","d023","d024","d025","d026","d027","d028","d029"]},{"title":"Dark","ids":["d040","d041","d042","d043","d044","d045","d046","d047","d048","d049"]},{"title":"Simple","ids":["d030","d031","d032","d033","d034","d035","d036","d037","d038","d039"]},{"title":"Calm Blue","ids":["d060","d061","d062","d063","d064","d065","d066","d067","d068","d069"]}];

export const REAL_DESIGNS: RealDesign[] = [
  ["d000","#F1D100","grid","#E5C500","#000000","#968100"],
  ["d001","#F9EFB2","grid","#E5DB9E","#000000","#375619"],
  ["d002","#E15651","grid","#CD4742","#FFADA8","#FFADA8"],
  ["d003","#E68630","grid","#DC7C26","#FEDF8A","#FFB862"],
  ["d004","#EFD368","grid","#E5C95E","#9F8312","#9F8312"],
  ["d005","#357B70","grid","#2B7166","#77EAD1","#77EAD1"],
  ["d006","#43BDAE","grid","#2FA99A","#176E63","#176E63"],
  ["d007","#367ED4","grid","#226AC0","#92C8F4","#92C8F4"],
  ["d008","#475ADC","grid","#3346C8","#9FB3F2","#9FB3F2"],
  ["d009","#7752DD","grid","#633EC9","#B298F3","#B298F3"],
  ["d010","#F9E6CE","grid","#E5D2BA","#5B5B5B","#5B5B5B"],
  ["d011","#E8DAAD","grid","#A7B99A","#464A46","#5E8046"],
  ["d012","#F4BDB8","grid","#E0A9A4","#503D84","#F677A4"],
  ["d013","#F3AF7E","grid","#DF9B6A","#2F5E54","#2F5E54"],
  ["d014","#B9D1B7","grid","#85B4B6","#3B6E71","#3B6E71"],
  ["d015","#DDC6A0","grid","#BAAB90","#40558A","#40558A"],
  ["d016","#EDE7D6","grid","#93CDC7","#64625A","#93CDC7"],
  ["d017","#EDE7D6","grid","#DBA581","#64625A","#DBA581"],
  ["d018","#EDE7D6","grid","#B8B8B8","#64625A","#B8B8B8"],
  ["d019","#D6D0AA","grid","#C4BE98","#122498","#918D74"],
  ["d020","#FBE6E1","ruled","#F4D4CC","#784D57","#784D57"],
  ["d021","#FFFFFF","ruled","#FFDAE9","#DD5D91","#DD5D91"],
  ["d022","#F6EFDC","grid","#E7DEC6","#B8525F","#B8525F"],
  ["d023","#E1E9F4","grid","#CED9E9","#5577A6","#5577A6"],
  ["d024","#D0C2D9","grid","#C2B0CE","#9072A2","#9072A2"],
  ["d025","#FFFCF1","grid","#EBE7D5","#B91810","#B91810"],
  ["d026","#FDF2F0","grid","#EACBD0","#D3949E","#D3949E"],
  ["d027","#FFDDEB","grid","#F4CADB","#A76680","#A76680"],
  ["d028","#FCF4EC","grid","#EDE2D7","#A995CC","#A995CC"],
  ["d029","#FFF9E9","grid","#E9E4D4","#708BC7","#708BC7"],
  ["d030","#FFFFFF","grid","#EBEBEB","#000000","#B3B3B3"],
  ["d031","#EDE4D3","dots","#E4DAC6","#1C1C1A","#1C1C1A"],
  ["d032","#E5EAE9","dots","#DBE2E1","#323B3A","#323B3A"],
  ["d033","#FFFFFF","grid","#CCEEF8","#000000","#CCEEF8"],
  ["d034","#FFFFFF","dots","#D7D7D7","#000000","#B3B3B3"],
  ["d035","#FFEABF","grid","#EAD3A2","#2B1B0E","#2B1B0E"],
  ["d036","#F9F8F4","ruled","#E9E7E0","#181715","#181715"],
  ["d037","#FFFFFF","ruled","#CCEEF8","#000000","#CCEEF8"],
  ["d038","#FFFFFF","ruled","#F4F4F4","#000000","#B3B3B3"],
  ["d039","#FFFFFF","grid","#FFE0E0","#000000","#FFE0E0"],
  ["d040","#1E1E1E","grid","#343434","#C1C1C1","#C1C1C1"],
  ["d041","#252020","grid","#383030","#A19494","#A19494"],
  ["d042","#1F1E2C","grid","#2F2E3F","#9694AD","#9694AD"],
  ["d043","#333645","grid","#404354","#9A9FB8","#9A9FB8"],
  ["d044","#1D2B2B","grid","#2C3A3A","#8CA8A8","#8CA8A8"],
  ["d045","#2D2D1F","grid","#393929","#B3B39B","#B3B39B"],
  ["d046","#352229","grid","#462E37","#BFA8B1","#BFA8B1"],
  ["d047","#0D2C3D","grid","#1A3A4C","#A4AFB5","#A4AFB5"],
  ["d048","#272F2F","grid","#374040","#A4B7B7","#A4B7B7"],
  ["d049","#38251B","grid","#422E24","#C9B8AF","#C9B8AF"],
  ["d050","#FFF701","grid","#EAE200","#000000","#A6A000"],
  ["d051","#D7FE1D","grid","#C4E914","#000000","#889F1A"],
  ["d052","#FF6120","grid","#F6520F","#000000","#A53508"],
  ["d053","#FF396C","grid","#E92154","#000000","#9C052C"],
  ["d054","#41D34A","grid","#2CB636","#000000","#0A7210"],
  ["d055","#FDE859","plain","","#000000","#B09E27"],
  ["d056","#FFF4B7","plain","","#000000","#BFAB44"],
  ["d057","#AFD8F4","plain","","#000000","#69A2C9"],
  ["d058","#FDBEB7","plain","","#000000","#CA7E76"],
  ["d059","#D6FEB7","plain","","#000000","#9CD471"],
  ["d060","#D5D5CB","grid","#CACABF","#574572","#86779B"],
  ["d061","#8BABA1","grid","#7AA194","#384F47","#51786B"],
  ["d062","#FBF6E2","ruled","#EBE5CE","#2428C0","#AFAFDE"],
  ["d063","#415E7B","ruled","#527292","#D4CEB8","#D4CEB8"],
  ["d064","#A1C6CC","grid","#97BCC2","#53787E","#53787E"],
  ["d065","#738FB2","dots","#6982A6","#C2BFB0","#C2BFB0"],
  ["d066","#F1F3E3","dots","#E3E6D2","#3C449A","#7E82AD"],
  ["d067","#F4F1E0","grid","#C5D1C5","#708481","#708481"],
  ["d068","#DEDCD0","grid","#C7C5B6","#3B4876","#3B4876"],
  ["d069","#F0F6D0","grid","#DEE3C0","#384F47","#384F47"],
];

/** Palettes shown on the reference website that were not in the supplied screenshots (likely further sections). */
export const EXTRA_SITE_PALETTES: [string, Pattern, string, string][] = [["#F5879E","dots","#E0738A","#006B42"],["#2B6153","grid","#215749","#F2AA7A"],["#FFFFFF","ruled","#EBEBEB","#B3B3B3"],["#F5C200","dots","#E0AD00","#BD8200"],["#EDB300","dots","#D99E00","#F21C17"],["#5350DF","grid","#6764E9","#20203A"],["#E8CFB2","dots","#D4BA9E","#0000CC"],["#E3E1D5","plain","","#E0A6C7"],["#02170C","plain","","#13CA6D"],["#E8E8D9","dots","#DEDBCC","#1A704F"],["#B8E3FA","dots","#A3D1E6","#F55238"],["#F5EAD6","plain","","#DE9E3F"],["#D1D1D1","dots","#B2B2B2","#A8A8A8"],["#82CFDB","dots","#6EBAC7","#F21A12"],["#0000CC","dots","#2626F2","#F5879E"],["#D6D6D6","dots","#C2C2C2","#FF4014"],["#B89A82","grid","#A4866E","#DB522A"],["#5D4C44","grid","#67564E","#27221E"],["#006B42","dots","#00572E","#F2879E"],["#FFE8D9","dots","#EAD4C4","#FA8F00"],["#F51C17","dots","#E30603","#EBB500"],["#F45F41","grid","#EA5537","#252420"],["#E8CABC","dots","#D6B5A8","#F2EDE6"]];
